export default "__VITE_ASSET__e3a0cd96__"